/* @flow */
import assets from "./assets";

const styles = {
  cellData: {
    alignment: "right"
  },
  cellCenterData: {
    alignment: "center"
  },
  cellNegativeData: {
    bold: true,
    color: "#CC0000"
  },
  cellPositiveData: {
    bold: true,
    color: "#007E33"
  },
  primaryHeaderCell: {
    fillColor: "#FFCD02",
    bold: true,
    alignment: "center"
  },
  headerCell: {
    fillColor: "#DBEEF3",
    bold: true,
    alignment: "center"
  },
  resultCell: {
    fillColor: "#F2F6F7",
    bold: true,
    alignment: "right"
  }
};

const demo_prospetto = {
  pageSize: "A4",
  pageMargins: [40, 60, 40, 70],
  defaultStyle: {
    fontSize: 12,
    bold: false
  },
  styles,
  header: {
    columns: [
      {
        image: assets.logo,
        width: 35,
        marginLeft: 20,
        marginTop: 3
      },
      {
        text: "",
        width: "*"
      }
    ]
  },
  footer: {
    fontSize: 10,
    color: "#616161",
    columns: [
      {
        stack: [
          {
            image: assets.logo,
            width: 25
          }
        ],
        marginLeft: 20
      },
      {
        text: "",
        width: "*"
      },
      {
        stack: [
          {
            text: "DEMO COMPANY Srl",
            bold: true,
            marginBottom: 3
          },
          "Viale Italia, 5 | 35100 Padova PD | Italy",
          "T: +39 000.00000 | F: +39 000.0000000",
          {
            text: "www.demo_company.demo"
          }
        ],
        marginTop: 10
      }
    ]
  },
  content: [
    /* Foglio Dati di Ingresso */
    {
      columns: [
        {
          width: "50%",
          text: "ANALISI ENERGETICA\nGAS",
          bold: true,
          fontSize: 25
        },
        {
          stack: [
            {
              columns: [
                {
                  width: 80,
                  text: "Cliente",
                  alignment: "right",
                  marginRight: 8
                },
                {
                  stack: [
                    {
                      text: {
                        fnString: "concatValues",
                        params: [
                          [
                            "preventivo.cliente.informazioni_anagrafiche.firstname",
                            "preventivo.cliente.informazioni_anagrafiche.lastname"
                          ]
                        ],
                        execute: true
                      }
                    },
                    {
                      text: {
                        fnString: "textValue",
                        params: [
                          "preventivo.cliente.informazioni_anagrafiche.indirizzo"
                        ],
                        execute: true
                      }
                    },
                    {
                      text: {
                        fnString: "textValue",
                        params: [
                          "preventivo.cliente.informazioni_anagrafiche.phone_number"
                        ],
                        execute: true
                      }
                    },
                    {
                      text: {
                        fnString: "textValue",
                        params: [
                          "preventivo.cliente.informazioni_anagrafiche.email"
                        ],
                        execute: true
                      }
                    }
                  ]
                }
              ],
              marginBottom: 10
            },
            {
              columns: [
                {
                  width: 80,
                  text: "Consulente",
                  alignment: "right",
                  marginRight: 8
                },
                {
                  stack: [
                    {
                      text: {
                        fnString: "concatValues",
                        params: [
                          [
                            "preventivo.consulente.dati_utente.name",
                            "preventivo.consulente.dati_utente.surname"
                          ]
                        ],
                        execute: true
                      }
                    },
                    {
                      text: {
                        fnString: "textValue",
                        params: ["preventivo.consulente.dati_utente.phone"],
                        execute: true
                      }
                    },
                    {
                      text: {
                        fnString: "textValue",
                        params: ["preventivo.consulente.dati_utente.email"],
                        execute: true
                      }
                    }
                  ]
                }
              ],
              marginRight: 10
            }
          ],
          marginTop: 12
        }
      ]
    },
    {
      text: "Sistema Riscaldamento",
      fontSize: 14,
      bold: true,
      marginTop: 35,
      marginBottom: 5
    },
    {
      table: {
        fnString: "datiIngressoSistemaRiscaldamento",
        params: ["preventivo.sistema_riscaldamento.tipologia"],
        execute: true
      }
    },
    {
      marginTop: 5,
      table: {
        fnString: "datiIngressoFinanziaria",
        params: [
          "preventivo.sistema_riscaldamento.tipologia",
          "preventivo.sistema_riscaldamento.anni_finanziamento"
        ],
        execute: true
      }
    }
  ]
};

export default {
  demo_prospetto
};
